import React from "react";

import { setSettingByKey } from "@/features/commissionSlice";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import _ from "lodash";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

export default function BonusFormRow({ disabled }) {
  const bonus = useSelector(
    (state) => state.commission.settings.bonus,
    shallowEqual,
  );

  const validations = useSelector(
    (state) => state.commission.validations.bonus,
    shallowEqual,
  );
  const dispatch = useDispatch();
  const handleFormData = React.useCallback(
    async (key, value) => {
      const cloneRow = _.cloneDeep(bonus);
      cloneRow[key] = value;
      dispatch(
        setSettingByKey({
          key: "bonus",
          value: cloneRow,
        }),
      );
    },
    [dispatch, bonus],
  );
  return (
    <React.Fragment>
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!validations?.bounsAmountErr}
              helperText={validations?.bounsAmountErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonus.bounsAmount}
              type="number"
              id="outlined-basic"
              label="到數獎金金額"
              variant="outlined"
              onChange={(event) =>
                handleFormData("bounsAmount", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!validations?.specialBounsConditionErr}
              helperText={validations?.specialBounsConditionErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonus.specialBounsCondition}
              type="number"
              id="outlined-basic"
              label="特別獎金達標數"
              variant="outlined"
              onChange={(event) =>
                handleFormData("specialBounsCondition", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!validations?.specialBounsAmountErr}
              helperText={validations?.specialBounsAmountErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonus.specialBounsAmount}
              type="number"
              id="outlined-basic"
              label="特別獎金金額"
              variant="outlined"
              onChange={(event) =>
                handleFormData("specialBounsAmount", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
}
